import React, { useState, useContext } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { AiOutlinePlus } from "react-icons/ai";
import "./droplist.css";
import WithAuthentication from "context/Authentication/AuthenticationContext.ts";
import ManagementContext from "context/WebInfo/ManagementContext";
import { BiMenu } from "react-icons/bi";
// import InsertProductModal from "../../admin-panel/product-management/insert-product";

export default function DropList() {
  const auth = useContext(WithAuthentication);
  const { setControllerProduct } = useContext(ManagementContext);
  const { setShowModalArticle, setType, showModalArticle } =
    useContext(ManagementContext);
  // const [addProductModal, setAddProductModal] = useState(false);

  return (
    <div>
      {auth.isLogged == true && (
        <Dropdown className="drop-items">
          <Dropdown.Toggle className="story-drop-toggle" id="dropdown-basic">
            <div className="add_drop-item">
              {auth.userInfo.userType === 0 ? (
                <AiOutlinePlus color="#fff" size={30} />
              ) : (
                <BiMenu color="#fff" size={30} />
              )}
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <div className="font-14-500">
              {auth.userInfo.userType == "0" ? (
                <div>
                  <Dropdown.Item
                    onClick={() =>
                      setControllerProduct({ show: true, type: "add" })
                    }
                  >
                    افزودن محصول
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      setShowModalArticle((prev) => !prev);
                      setType("add");
                    }}
                  >
                    افزودن مقاله
                  </Dropdown.Item>
                  <Dropdown.Item href="/admin-panel/orders">
                    سفارشات
                  </Dropdown.Item>
                  <Dropdown.Item href="/admin-panel/user-management">
                    مدیریت کاربران
                  </Dropdown.Item>
                  <Dropdown.Item href="/admin-panel/category-management">
                    مدیریت دسته بندی
                  </Dropdown.Item>
                   <Dropdown.Item href="/admin-panel/option-management">
                    مدیریت ویژگی ها
                  </Dropdown.Item>
                  {/*
                  <Dropdown.Item href="/admin-panel/customer-club">
                    باشگاه مشتریان{" "}
                  </Dropdown.Item> */}
                </div>
              ) : (
                <div>
                  <Dropdown.Item href="/customer-panel/profile">
                    پروفایل
                  </Dropdown.Item>
                  <Dropdown.Item href="/customer-panel/orders">
                    سفارشات
                  </Dropdown.Item>
                </div>
              )}
              <Dropdown.Item
                href="/"
                onClick={() => {
                  auth.logout();
                }}
              >
                خروج
              </Dropdown.Item>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      )}
     
    </div>
  );
}
